import React, { useRef, useState } from 'react';

import cx from 'classnames';

import noop from 'utils/noop';

import { IAddNewContentProps } from '../BlockWrapper/types';
import styles from './index.module.css';
import Menu from './Menu';
import BluePlusButton from './shared/BluePlusButton';

function AddNewContent({
  className,
  onOpenPopup,
  onClosePopup,
  onAdd = noop,
  isVisible,
  isInsideAccordion,
}: IAddNewContentProps) {
  const [showPopup, setShowPopup] = useState(false);
  const plusButtonRef = useRef(null);

  const handleOpenPopup = () => {
    setShowPopup(true);
    onOpenPopup?.();
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    onClosePopup?.();
  };

  return (
    <div className={cx(styles.wrapper, isVisible && styles.visible, className, 'custom-add-new-content-wrapper')}>
      <button
        tabIndex={-1}
        type="button"
        className={cx(styles.iconBlock, 'custom-add-new-content-button')}
        onClick={handleOpenPopup}
        ref={plusButtonRef}
      >
        <BluePlusButton className={cx(styles.plus, 'custom-add-new-content-button-icon')} />
      </button>

      {showPopup && (
        <Menu
          anchorRef={plusButtonRef}
          onClose={handleClosePopup}
          onAdd={onAdd}
          isInsideAccordion={isInsideAccordion}
        />
      )}
    </div>
  );
}

export default AddNewContent;
